<app-popup-content #popup [hideSecondPart]="true">
  <div content1>
    <app-activate-account-content
      [link]="'/:lang/my-reservation/authorization-group'|i18nRoute"
      [popup]="popup"
      linkText="back_to_home"
    ></app-activate-account-content>
  </div>
</app-popup-content>
